import { render, staticRenderFns } from "./ClerkPage.vue?vue&type=template&id=33487407&scoped=true"
import script from "./ClerkPage.vue?vue&type=script&lang=js"
export * from "./ClerkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33487407",
  null
  
)

export default component.exports